import {EventEmitter} from 'events';
const eventEmitter=new EventEmitter();
let activeEvents=new Set();
const newEvent=(name,cb)=>{
    activeEvents.add(name);
    eventEmitter.on(name,cb);
};
const emitEvent=(name,param)=>{
    eventEmitter.emit(name,param);
};
const deleteEvent=(name)=>{
    if(!activeEvents.has(name)){
        return;
    }
    eventEmitter.removeAllListeners(name);
    activeEvents.delete(name);
};
const chooseEvents=(sw)=>{
    if(sw===undefined){
        sw = '';
    }
    let q=[];
    for(const x of activeEvents){
        if(x.startsWith(sw)){
            q.push(x);
        }
    }
    return q;
};
const emitAll=(sw,param)=>{
    const q=chooseEvents(sw);
    for(const x of q){
        emitEvent(x,param);
    }
};
const deleteAll=(sw)=>{
    const q=chooseEvents(sw);
    for(const x of q){
        deleteEvent(x);
    }
};
const deleteAllAndNewEvent=(name,cb)=>{
    deleteAll(name);
    newEvent(name,cb);
};
export default {
    newEvent,
    emitEvent,
    deleteEvent,
    chooseEvents,
    emitAll,
    deleteAll,
    deleteAllAndNewEvent,
};

